<template>
  <form>
    <v-row class="py-0">
      <v-col class="py-0" cols="12" sm="12" md="11" lg="11">
        <form-edit
          :form="purchasePayment"
          :vendors="vendors"
          :listBanks="listBanks"
          :listInvoice="listInvoice"
          ref="formEdit"
          v-if="!edit"
        ></form-edit>
        <detail :id="id" :purchasePayment="purchasePayment" v-if="edit"></detail>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-btn color="success" @click="updateItem">
              <v-icon>
                mdi-content-save
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-btn color="success" @click="printer">
              <v-icon>
                mdi-printer
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-btn color="success" @click="openAccountNumber">
              <v-icon>
                mdi-account-credit-card
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit && !purchasePayment.hidden">
          <v-col cols="12" class="py-0">
            <v-btn color="success" @click="editItem">
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit && !purchasePayment.hidden">
          <v-col cols="12" class="py-0">
            <v-btn color="error" @click="dialogDelete">
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click="cancel">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" @click="back">
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="blue-grey" dark v-on="on" @click="dialogAuditHistory = true">
                  <v-icon>
                    mdi-history
                  </v-icon>
                </v-btn>
              </template>
              <span>History</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-delete
      :id="id"
      :dialog="dialog"
      :invoiceNumber="purchasePayment.voucherNumber"
      title="Purchase Payment"
      @deleteItem="deleteItem"
      @close="close"
    ></dialog-delete>
    <dialog-account-number
      :dialog="dialogAccountNumber"
      :banks="banks"
      :form="accountNumber"
      :listAccountNumber="listAccountNumber"
      :id="purchasePayment.id"
      @close="dialogAccountNumber = false"
      @save="saveAccountNumber"
      @update="updateAccountNumber"
    ></dialog-account-number>

    <dialog-audit-history
      :dialog="dialogAuditHistory"
      entity-type="PurchasePayment"
      :entity-id="id"
      @close="dialogAuditHistory = false"
    ></dialog-audit-history>
  </form>
</template>

<script>
import Detail from "./DetailPurchasePayment";
import FormEdit from "./FormPurchasePayment";
import { mapState } from "vuex";
import DialogDelete from "@/components/DialogDelete";
import DialogAccountNumber from "./DialogAccountNumber.vue";
import DialogAuditHistory from "@/components/DialogAuditHistory.vue";

export default {
  name: "purchase-payment-view",
  components: {
    Detail,
    "form-edit": FormEdit,
    DialogDelete,
    DialogAccountNumber,
    DialogAuditHistory,
  },
  props: {
    id: {
      type: Number,
      default: () => undefined,
    },
  },
  data: () => ({
    edit: true,
    listBanks: [],
    listInvoice: [],
    purchasePayment: {},
    dialog: false,
    dialogAccountNumber: false,
    dialogAuditHistory: false,
    accountNumber: {},
    banks: [],
    listAccountNumber: [],
  }),
  computed: {
    ...mapState("external", ["vendors"]),
  },
  methods: {
    async getPurchasePayment() {
      await this.$store.dispatch("purchasePayment/getById", this.id).then(response => {
        this.purchasePayment = response.data;
        this.getAccountNumbers(this.purchasePayment.vendorId);
      });
    },
    async getListInvoice() {
      await this.$store
        .dispatch("purchasePayment/getListInvoiceById", this.id)
        .then(response => (this.listInvoice = response.data));
    },
    async getAccountNumbers(vendorId) {
      await this.$store
        .dispatch("purchasePayment/getAccountNumbers", { id: vendorId, type: 0 })
        .then(response => {
          this.listAccountNumber = response.data;
        });
    },
    back() {
      this.$router.go(-1);
    },
    editItem() {
      this.edit = false;
    },
    updateItem() {
      this.$refs.formEdit.update();
    },
    dialogDelete() {
      this.dialog = true;
    },
    async deleteItem(id) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("purchasePayment/delete", id)
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    close() {
      this.dialog = false;
    },
    cancel() {
      this.edit = true;
    },
    getBanks() {
      this.$store.dispatch("chartOfAccount/getBanks").then(response => {
        this.listBanks = response.data;
      });
    },
    printer() {
      this.$router.push({ name: "Payment Voucher Purchase", params: { id: this.id } });
    },
    openAccountNumber() {
      this.dialogAccountNumber = true;
      if (this.purchasePayment.accountNumber) {
        this.accountNumber = this.purchasePayment.accountNumber;
      } else {
        this.accountNumber = {
          id: null,
          accountNumber: "",
          bankExternal: null,
          ownerName: "",
          different: true,
          vendorId: this.purchasePayment.vendorId,
          type: 0,
        };
      }
    },
    updateAccountNumber(form) {
      this.accountNumber = form;
    },
    async saveAccountNumber(form) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("purchaseInvoice/saveAccountNumber", form)
        .then(() => {
          this.dialogAccountNumber = false;
          this.$store.commit("SET_LOADER", false);
          this.getPurchasePayment();
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async getBankExternals() {
      await this.$store.dispatch("bank/getExternals").then(response => {
        this.banks = response.data;
      });
    },
    async getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([
        this.getBanks(),
        this.getPurchasePayment(),
        this.$store.dispatch("external/getVendors"),
        this.getListInvoice(),
        this.getBankExternals(),
      ])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
  mounted() {
    this.getInitialData();
  },
};
</script>

<style></style>
